import React from 'react';
import R from 'ramda';
import Checkbox from 'material-ui/Checkbox';
import { mapZipToDetailLocation, mapLocationToZips } from '../../../common/app/helperFunctions';
import { SelectButton } from '../../app/components';
import './styles.css';

const ZipFilter = ({
  activeLocation, parent, subParent, areas, towns, zips, capitalCounter, sudurnesCounter,
  nordurlandCounter, austurlandCounter, vestfirdirCounter, vesturlandCounter, sudurlandCounter,
  reykjavikCounter, kopavogurCounter, hfjCounter, gardabaerCounter, mosoCounter,
  seltjarnanesCounter, changeActiveLocation, onSelectArea, onDeSelectArea,
  onSelectTown, onDeSelectTown, onSelectZip, onDeselectZip,
}) => (
  <div className="zip-filter">
    <h2 className="zip-nav">
      <button onClick={e => changeActiveLocation(e, 'areas', '', '')}>Svæði</button>
      {parent !== '' &&
        <div>
          <span className="icon-small-arrow-icon" />
          <button
            onClick={e => changeActiveLocation(e, parent === 'Höfuðborgarsvæðið' ? 'towns' : 'zips', parent, '')}
          >
            {parent}
          </button>
        </div>
      }
      {subParent !== '' &&
        <div>
          <span className="icon-small-arrow-icon" />
          <button
            onClick={e => changeActiveLocation(e, 'zips', parent, subParent)}
          >
            {subParent}
          </button>
        </div>
      }
    </h2>
    {activeLocation === 'areas' &&
      <div className="areas">
        <SelectButton
          content={<div><span className="icon-capital-icon" /><p>Höfuðborgar-<br />svæðið</p></div>}
          selected={R.contains('capital', areas)}
          disabled={false}
          onClick={e => R.contains('capital', areas) ? onDeSelectArea(e, 'capital') : onSelectArea(e, 'capital')}
          containsDetails={R.contains('capital', areas)}
          numberOfSelectedItems={capitalCounter}
          detailsOnClick={e => changeActiveLocation(e, 'towns', 'Höfuðborgarsvæðið', '')}
        />
        <SelectButton
          content={<div><span className="icon-sudurnes-icon" /><p>Suðurnes</p></div>}
          selected={R.contains('sudurnes', areas)}
          disabled={false}
          onClick={e => R.contains('sudurnes', areas) ? onDeSelectArea(e, 'sudurnes') : onSelectArea(e, 'sudurnes')}
          containsDetails={R.contains('sudurnes', areas)}
          numberOfSelectedItems={sudurnesCounter}
          detailsOnClick={e => changeActiveLocation(e, 'zips', 'Suðurnes', '')}
        />
        <SelectButton
          content={<div><span className="icon-nordurland-icon" /><p>Norðurland</p></div>}
          selected={R.contains('nordurland', areas)}
          disabled={false}
          onClick={e => R.contains('nordurland', areas) ? onDeSelectArea(e, 'nordurland') : onSelectArea(e, 'nordurland')}
          containsDetails={R.contains('nordurland', areas)}
          numberOfSelectedItems={nordurlandCounter}
          detailsOnClick={e => changeActiveLocation(e, 'zips', 'Norðurland', '')}
        />
        <SelectButton
          content={<div><span className="icon-vestfirdir-icon" /><p>Vestfirðir</p></div>}
          selected={R.contains('vestfirdir', areas)}
          disabled={false}
          onClick={e => R.contains('vestfirdir', areas) ? onDeSelectArea(e, 'vestfirdir') : onSelectArea(e, 'vestfirdir')}
          containsDetails={R.contains('vestfirdir', areas)}
          numberOfSelectedItems={vestfirdirCounter}
          detailsOnClick={e => changeActiveLocation(e, 'zips', 'Vestfirðir', '')}
        />
        <SelectButton
          content={<div><span className="icon-vesturland-icon" /><p>Vesturland</p></div>}
          selected={R.contains('vesturland', areas)}
          disabled={false}
          onClick={e => R.contains('vesturland', areas) ? onDeSelectArea(e, 'vesturland') : onSelectArea(e, 'vesturland')}
          containsDetails={R.contains('vesturland', areas)}
          numberOfSelectedItems={vesturlandCounter}
          detailsOnClick={e => changeActiveLocation(e, 'zips', 'Vesturland', '')}
        />
        <SelectButton
          content={<div><span className="icon-austurland-icon" /><p>Austurland</p></div>}
          selected={R.contains('austurland', areas)}
          disabled={false}
          onClick={e => R.contains('austurland', areas) ? onDeSelectArea(e, 'austurland') : onSelectArea(e, 'austurland')}
          containsDetails={R.contains('austurland', areas)}
          numberOfSelectedItems={austurlandCounter}
          detailsOnClick={e => changeActiveLocation(e, 'zips', 'Austurland', '')}
        />
        <SelectButton
          content={<div><span className="icon-sudurland-icon" /><p>Suðurland</p></div>}
          selected={R.contains('sudurland', areas)}
          disabled={false}
          onClick={e => R.contains('sudurland', areas) ? onDeSelectArea(e, 'sudurland') : onSelectArea(e, 'sudurland')}
          containsDetails={R.contains('sudurland', areas)}
          numberOfSelectedItems={sudurlandCounter}
          detailsOnClick={e => changeActiveLocation(e, 'zips', 'Suðurland', '')}
        />
      </div>
    }
    {activeLocation === 'towns' &&
      <div className="towns">
        <SelectButton
          content={<div><span className="icon-reykjavik-icon" /><p>Reykjavík</p></div>}
          selected={R.contains('reykjavik', towns)}
          disabled={false}
          onClick={e => R.contains('reykjavik', towns) ? onDeSelectTown(e, 'reykjavik') : onSelectTown(e, 'reykjavik')}
          containsDetails={R.contains('reykjavik', towns)}
          numberOfSelectedItems={reykjavikCounter}
          detailsOnClick={e => changeActiveLocation(e, 'zips', 'Höfuðborgarsvæðið', 'Reykjavík')}
        />
        <SelectButton
          content={<div><span className="icon-kopavogur-icon" /><p>Kópavogur</p></div>}
          selected={R.contains('kopavogur', towns)}
          disabled={false}
          onClick={e => R.contains('kopavogur', towns) ? onDeSelectTown(e, 'kopavogur') : onSelectTown(e, 'kopavogur')}
          containsDetails={R.contains('kopavogur', towns)}
          numberOfSelectedItems={kopavogurCounter}
          detailsOnClick={e => changeActiveLocation(e, 'zips', 'Höfuðborgarsvæðið', 'Kópavogur')}
        />
        <SelectButton
          content={<div><span className="icon-gardabaer-icon" /><p>Garðabær</p></div>}
          selected={R.contains('gardabaer', towns)}
          disabled={false}
          onClick={e => R.contains('gardabaer', towns) ? onDeSelectTown(e, 'gardabaer') : onSelectTown(e, 'gardabaer')}
          containsDetails={R.contains('gardabaer', towns)}
          numberOfSelectedItems={gardabaerCounter}
          detailsOnClick={e => changeActiveLocation(e, 'zips', 'Höfuðborgarsvæðið', 'Garðabær')}
        />
        <SelectButton
          content={<div><span className="icon-hfj-icon" /><p>Hafnarfjörður</p></div>}
          selected={R.contains('hfj', towns)}
          disabled={false}
          onClick={e => R.contains('hfj', towns) ? onDeSelectTown(e, 'hfj') : onSelectTown(e, 'hfj')}
          containsDetails={R.contains('hfj', towns)}
          numberOfSelectedItems={hfjCounter}
          detailsOnClick={e => changeActiveLocation(e, 'zips', 'Höfuðborgarsvæðið', 'Hafnarfjörður')}
        />
        <SelectButton
          content={<div><span className="icon-moso-icon" /><p>Mosfellsbær</p></div>}
          selected={R.contains('moso', towns)}
          disabled={false}
          onClick={e => R.contains('moso', towns) ? onDeSelectTown(e, 'moso') : onSelectTown(e, 'moso')}
          containsDetails={R.contains('moso', towns)}
          numberOfSelectedItems={mosoCounter}
          detailsOnClick={e => changeActiveLocation(e, 'zips', 'Höfuðborgarsvæðið', 'Mosfellsbær')}
        />
        <SelectButton
          content={<div><span className="icon-seltjarnanes-icon" /><p>Seltjarnarnes</p></div>}
          selected={R.contains('seltjarnanes', towns)}
          disabled={false}
          onClick={e => R.contains('seltjarnanes', towns) ? onDeSelectTown(e, 'seltjarnanes') : onSelectTown(e, 'seltjarnanes')}
          containsDetails={R.contains('seltjarnanes', towns)}
          numberOfSelectedItems={seltjarnanesCounter}
          detailsOnClick={e => changeActiveLocation(e, 'zips', 'Höfuðborgarsvæðið', 'Seltjarnarnes')}
        />
      </div>
    }
    {activeLocation === 'zips' &&
      <div className="zips">
        {mapLocationToZips(subParent !== '' ? subParent : parent).map((zip, key) => (
          <Checkbox
            key={key}
            label={`${zip} ${mapZipToDetailLocation(zip)}`}
            checked={R.contains(zip, zips)}
            onCheck={e =>
              R.contains(zip, zips) ?
                onDeselectZip(e, zip, subParent !== '' ? subParent : parent)
              :
                onSelectZip(e, zip, subParent !== '' ? subParent : parent)
            }
          />
        ))}
      </div>
    }
  </div>
);

ZipFilter.propTypes = {
  activeLocation: React.PropTypes.string.isRequired,
  parent: React.PropTypes.string.isRequired,
  subParent: React.PropTypes.string.isRequired,
  areas: React.PropTypes.array.isRequired,
  towns: React.PropTypes.array.isRequired,
  zips: React.PropTypes.array.isRequired,
  capitalCounter: React.PropTypes.number.isRequired,
  sudurnesCounter: React.PropTypes.number.isRequired,
  nordurlandCounter: React.PropTypes.number.isRequired,
  austurlandCounter: React.PropTypes.number.isRequired,
  vestfirdirCounter: React.PropTypes.number.isRequired,
  vesturlandCounter: React.PropTypes.number.isRequired,
  sudurlandCounter: React.PropTypes.number.isRequired,
  reykjavikCounter: React.PropTypes.number.isRequired,
  kopavogurCounter: React.PropTypes.number.isRequired,
  hfjCounter: React.PropTypes.number.isRequired,
  gardabaerCounter: React.PropTypes.number.isRequired,
  mosoCounter: React.PropTypes.number.isRequired,
  seltjarnanesCounter: React.PropTypes.number.isRequired,
  changeActiveLocation: React.PropTypes.func.isRequired,
  onSelectArea: React.PropTypes.func.isRequired,
  onDeSelectArea: React.PropTypes.func.isRequired,
  onSelectTown: React.PropTypes.func.isRequired,
  onDeSelectTown: React.PropTypes.func.isRequired,
  onSelectZip: React.PropTypes.func.isRequired,
  onDeselectZip: React.PropTypes.func.isRequired,
};

export default ZipFilter;



// WEBPACK FOOTER //
// ./src/browser/filters/ZipFilter/ZipFilter.js